import Vue from 'vue'
import { isDev } from '~/utils/env'

let appConfigs = {}
if (isDev()) {
  appConfigs.customerUrl = "http://localhost:3000"
  appConfigs.apiUrl = "http://api.dev.localhost:8888"
} else {
  appConfigs.customerUrl = "https://cus.spde.menu"
  appConfigs.apiUrl = "https://spdm-api.saucer-saas.com"
}

// 共通
// appConfigs.cloudinaryApiKey = "239742381986822"


Vue.prototype.$appConfigs = appConfigs